import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Table, Card, Spin, Tag } from "antd";
import moment from "moment";
import ErrorBlock from "../../../components/UI/ErrorBlock.js";
import { fetchDepositHistory } from "../../../utils/CustomerService/api.js";
import "../../../App.css";

const { Column, ColumnGroup } = Table;

function DepositHistory() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);

  const {
    data: initialData,
    isLoading: isInitialLoading,
    isError,
  } = useQuery({
    queryKey: ["deposit", currentPage, pageSize],
    queryFn: () =>
      fetchDepositHistory({
        page: currentPage,
        pageSize,
      }),
    keepPreviousData: true,
  });

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) setPageSize(size);
  };

  const dataSource = useMemo(() => {
    return initialData?.results?.map((deposit) => ({
      key: deposit.id,
      host: `${deposit.customer?.userAccount?.first_name} ${deposit.customer?.userAccount?.last_name}`,
      amount: `${deposit.amount} ETB`,
      transactionID: deposit.transaction_id,
      paymentMethod: deposit.payment_method,
      timeStamp: moment(deposit.time_Stamp).format("MMM D, YYYY h:mm A"),
      status: deposit.status,
    }));
  }, [initialData]);

  if (isError) {
    return (
      <ErrorBlock
        title="Failed to fetch data"
        message="No Deposit History data found."
      />
    );
  }

  return (
    <>
      <div className="p-4 bg-white rounded-lg shadow-md dark:bg-gray-900 text-gray-900 dark:text-white">

        {isInitialLoading ? (
          <Card>
            <Spin /> Loading ...
          </Card>
        ) : (
          <Table
            dataSource={dataSource}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: initialData?.totalCount || 0,
              onChange: handlePageChange,
              showSizeChanger: true,
              responsive: true,
            }}
            scroll={{ x: true }}
            className="responsive-table"
          >
            <ColumnGroup>
              <Column title="Host" key="host" dataIndex="host" />
              <Column title="Amount" key="amount" dataIndex="amount" />
              <Column
                title="Transaction ID"
                key="transactionID"
                dataIndex="transactionID"
              />
              <Column
                title="Payment Method"
                key="paymentMethod"
                dataIndex="paymentMethod"
              />
              <Column
                title="Time Stamp"
                key="timeStamp"
                dataIndex="timeStamp"
              />
              <Column
                title="Status"
                key="status"
                dataIndex="status"
                render={(status) => (
                  <Tag
                    className={
                      status === "SUCCESS"
                        ? "bg-green-600 text-white px-4 py-1 rounded-md"
                        : "gold"
                    }
                    key={status.toString()}
                  >
                    {status === "SUCCESS" ? "Completed" : "Pending"}
                  </Tag>
                )}
              />
            </ColumnGroup>
          </Table>
        )}
      </div>
    </>
  );
}

export default DepositHistory;
